import React, { useEffect, useRef, useMemo } from 'react';
import { ADSENSE_CLIENT, AD_SLOTS } from '../../utils/constants';

const AdCMP = ({ dataAdSlot, adSize = '', isTagNeeded = false }) => {
  const adRef = useRef(null);
  const pushed = useRef(false);
  const isFixed = Boolean(adSize);

  const { width, height } = useMemo(() => {
    if (!adSize) return { width: null, height: null };
    const [w, h] = adSize.split('x').map(Number);
    return { width: w, height: h };
  }, [adSize]);

  const slot = dataAdSlot || AD_SLOTS['728x90'];

  useEffect(() => { pushed.current = false; }, [slot]);

  useEffect(() => {
    const timer = setTimeout(() => {
      try {
        if (window.adsbygoogle && adRef.current && !pushed.current) {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
          pushed.current = true;
        }
      } catch (e) {}
    }, 200);
    return () => clearTimeout(timer);
  }, [slot]);

  return (
    <div className="w-full flex flex-col items-center justify-center overflow-hidden" style={{ minHeight: isFixed ? `${height}px` : 50 }}>
      {isTagNeeded && <p className="ad-label">Advertisement</p>}
      <ins
        ref={adRef}
        className="adsbygoogle block mx-auto text-center"
        style={{ width: isFixed ? `${width}px` : '100%', height: isFixed ? `${height}px` : undefined }}
        data-ad-client={ADSENSE_CLIENT}
        data-ad-slot={slot}
        data-ad-format={isFixed ? undefined : 'auto'}
        data-full-width-responsive="true"
      />
    </div>
  );
};

export default AdCMP;
